import moment from "moment";

export const formatDate = (dateString: string | undefined): string => {
  if (!dateString) {
    return '';
  }

  const momentLocale = moment.locale()
  if (momentLocale === 'en') {
    return moment(dateString).format('MM/DD/YYYY');
  }
  return moment(dateString).format('YYYY.MM.DD');

  // const date = new Date(dateString);
  //
  // const y = date.getFullYear();
  // const m = date.getMonth() + 1;
  // const d = date.getDate();
  //
  // return y + '.' + (m <= 9 ? '0' + m : m) + '.' + (d <= 9 ? '0' + d : d);
};

export const formatDateTime = (dateString: string | undefined): string => {
  if (!dateString) {
    return '';
  }

  // Format usa
  const momentLocale = moment.locale()
  if (momentLocale === 'en') {
    return moment(dateString).format('MM/DD/YYYY HH:mm');
  }

  return moment(dateString).format('YYYY.MM.DD HH:mm');

  // const date = new Date(dateString);
  // const y = date.getFullYear();
  // const m = date.getMonth() + 1;
  // const d = date.getDate();
  // const h = date.getHours();
  // const min = date.getMinutes();
  //
  // return (
  //   y +
  //   '.' +
  //   (m <= 9 ? '0' + m : m) +
  //   '.' +
  //   (d <= 9 ? '0' + d : d) +
  //   ' ' +
  //   (h <= 9 ? '0' + h : h) +
  //   ':' +
  //   (min <= 9 ? '0' + min : min)
  // );
};
